<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.userName"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看-->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 查看
import viewDialog from './components/viewDialog'
// 终端恢复申请API
import { loadStoreVisitCheckInfoListDataApi, exportStoreVisitCheckInfoListDataApi } from '@/api/v2/storeVisitCheckInfo';

export default {
  name: 'StoreVisitCheckInfoView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    viewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'store_visit_check_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['store_visit_check_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['store_visit_check_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          storeName: '',
          userName: '',
          searchDate: 'month'
        }
      },
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: ''
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'tsi.province_name', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'tsi.city_name', width: 100 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
      { prop: 'storeName', label: '店名', filterColumn: 'tsi.store_name', width: 160 },
      { prop: 'realStoreName', label: '实际店名', filterColumn: 'tsi.real_store_name', width: 160 },
      { prop: 'userName', label: '走访人', filterColumn: 'tu.name', width: 120 },
      { prop: 'checkDate', label: '检查日期', filterColumn: 'tsvci.check_date', width: 120 },
      { prop: 'isChangeCertificateNoValue', label: '有无变更专卖证号', filterColumn: 'tsvci.is_change_certificate_no', filterValue: 'isChangeCertificateNo', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 160 },
      { prop: 'oldCertificateNo', label: '原专卖证号', filterColumn: 'tsvci.old_certificate_no', width: 160 },
      { prop: 'newCertificateNo', label: '新专卖证号', filterColumn: 'tsvci.new_certificate_no', width: 160 },
      { prop: 'isChangeCertificateEndDateValue', label: '有无变更专卖截止日期', filterColumn: 'tsvci.is_change_certificate_end_date', filterValue: 'isChangeCertificateEndDate', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 180 },
      { prop: 'oldEndDate', label: '原截止日期', filterColumn: 'tsvci.old_end_date', width: 120 },
      { prop: 'newEndDate', label: '新截止日期', filterColumn: 'tsvci.new_end_date', width: 120 },
      { prop: 'isChangeLevelValue', label: '有无变更档位', filterColumn: 'tsvci.is_change_level', filterValue: 'isChangeLevel', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 140 },
      { prop: 'oldLevelName', label: '原档位', filterColumn: 'tsvci.old_level_name', width: 120 },
      { prop: 'newLevelName', label: '新档位', filterColumn: 'tsvci.new_level_name', width: 120 },
      { prop: 'isChangeBenxiangPhoneValue', label: '有无变更本香注册手机号', filterColumn: 'tsvci.is_change_benxiang_phone', filterValue: 'isChangeBenxiangPhone', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 190 },
      { prop: 'oldBenxiangPhone', label: '原注册手机号', filterColumn: 'tsvci.old_benxiang_phone', width: 140 },
      { prop: 'newBenxiangPhone', label: '新注册手机号', filterColumn: 'tsvci.new_benxiang_phone', width: 140 },
      { prop: 'isChangeBenxiangStoreNoValue', label: '有无变更本香门店码', filterColumn: 'tsvci.is_change_benxiang_store_no', filterValue: 'isChangeBenxiangStoreNo', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 180 },
      { prop: 'oldBenxiangStoreNo', label: '原本香门店码', filterColumn: 'tsvci.old_benxiang_store_no', width: 140 },
      { prop: 'newBenxiangStoreNo', label: '新本香门店码', filterColumn: 'tsvci.new_benxiang_store_no', width: 140 },
      { prop: 'isChangeMailAddressValue', label: '有无变更邮寄地址', filterColumn: 'tsvci.is_change_mail_address', filterValue: 'isChangeMailAddress', filterArray: [{ label: '有变更', value: 1 }, { label: '无变更', value: 2 }], width: 180 },
      { prop: 'oldMailAddress', label: '原邮寄地址', filterColumn: 'tsvci.old_mail_address', width: 180 },
      { prop: 'newMailAddress', label: '新邮寄地址', filterColumn: 'tsvci.new_mail_address', width: 180 },
      { prop: 'operatorName', filterColumn: 'tsvci.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'tsvci.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadStoreVisitCheckInfoListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    viewFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的数据', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看终端走访检查信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportStoreVisitCheckInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
